import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ApprovalService} from '../../../service/approval.service';
import {MatTableDataSource} from '@angular/material/table';
import {DispatchPendingModel} from '../../../shared/dto/dispatch-pending.model';
import Swal, {default as swal} from 'sweetalert2';

@Component({
  selector: 'app-scan-pending-data',
  templateUrl: './scan-pending-data.component.html',
  styleUrls: ['./scan-pending-data.component.scss']
})
export class ScanPendingDataComponent implements OnInit {
  userName: string;
  sidNo: string;
  scanPending: DispatchPendingModel = new DispatchPendingModel();
  isError: boolean = false;
  isSucess: boolean = false;
  type:string;

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal, private router: Router) {
    this.route.paramMap.subscribe(params => {
      this.sidNo = this.decodeBase64(params.get('sid'));
      this.type = params.get('type');
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  decodeBase64(code: string): string {
    return atob(code);
  }

  sendDispatch() {
    this.scanPending.sidNo=this.sidNo;
    this.scanPending.loginUser=this.userName;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to send for dispatch?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.sendToDispatch(this.scanPending).subscribe(
          (result: any) => {

            if (result.value == 'SUC') {
              swal.fire('Success', 'Applicant Details Updated', 'success');
              this.router.navigate(['/dashboard/scan-pending', this.type] );
              this.approvalService.close();
            } else {
              swal.fire('Warning', 'Please Upload at least one document', 'warning');
            }
          },
          (error) => {
            swal.fire('Error', 'Error When Updating the Request', 'error');
            // this.isError = true;
          },
        );
      } else {
      }
    });
  }
}
